import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
  CircularProgress,
} from "@mui/material";
import { apiGet } from "../../utils/apiClient";

const formatDate = (iso) =>
  new Date(iso).toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });

export default function LocationMultiDaySessionsTab({ locationId }) {
  const [sessions, setSessions] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiGet(`locations/${locationId}/multi-day-sessions`)
      .then(setSessions)
      .catch((e) => setError(e.message));
  }, [locationId]);

  if (error)
    return (
      <Typography color="error" sx={{ p: 2 }}>
        {error}
      </Typography>
    );
  if (!sessions) return <CircularProgress sx={{ m: 2 }} />;

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Active Multi-Day Sessions
      </Typography>
      {sessions.length === 0 ? (
        <Typography color="text.secondary">No active sessions</Typography>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Package Name</TableCell>
              <TableCell>Locker #</TableCell>
              <TableCell>Tower ID</TableCell>
              <TableCell>Duration</TableCell>
              <TableCell>Ends</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sessions.map((s) => (
              <TableRow
                key={s.packageId}
                sx={
                  s.isExpired
                    ? { backgroundColor: "rgba(211, 47, 47, 0.08)" }
                    : {}
                }
              >
                <TableCell>{s.name}</TableCell>
                <TableCell>{s.lockerId}</TableCell>
                <TableCell sx={{ fontFamily: "monospace", fontSize: "0.8em" }}>
                  {s.towerId}
                </TableCell>
                <TableCell>{s.rentalDurationDays}d</TableCell>
                <TableCell>{formatDate(s.sessionExpiresAt)}</TableCell>
                <TableCell>
                  <Chip
                    label={s.isExpired ? "Expired" : "Active"}
                    color={s.isExpired ? "error" : "success"}
                    size="small"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  );
}
